import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  toggle: true,
  activeTab: "/"
};

const toggleSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setToggle: (state, action) => {
        state.toggle = action.payload
    },
    setActiveTab: (state, action) => {
        state.activeTab = action.payload
    }
  },
});

export const { setToggle, setActiveTab } = toggleSlice.actions;
export default toggleSlice.reducer;